import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { fadeInOutAnimation } from 'src/app/animations/fade-in-out.animation';
import { DailyMenu } from 'src/app/api/contracts/menu';
import { Product } from 'src/app/api/contracts/product';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  animations: [fadeInOutAnimation()],
})
export class ProductListComponent implements OnInit, AfterViewInit {
  @Input() products: Product[] | undefined = undefined;
  @Input() scrollTrigger!: Subject<void>;
  @Input() hideBuyButton: boolean = false;
  @Output() productClicked = new EventEmitter<Product>();

  @ViewChild('productListSwiper') productListSwiper!: ElementRef;

  constructor() {}

  ngOnInit() {
    this.scrollTrigger.pipe().subscribe(() => {
      this.scrollProductListToStart();
    });
  }

  ngAfterViewInit() {
    this.setSwiperElementSlidesPerViewAttribute();
    this.registerSlideMoving();
  }

  @HostListener('window:resize', ['$event.target.innerWidth'])
  handleWindowResize(width: number): void {
    this.setSwiperElementSlidesPerViewAttribute(width);
  }

  onProductClicked(product: Product): void {
    this.productClicked.next(product);
  }

  listTrackFn(index: number, item: Product): number {
    return item.id;
  }

  private scrollProductListToStart(): void {
    setTimeout(() => {
      this.productListSwiper.nativeElement.swiper.slideTo(0, 100);
    });
  }

  private setSwiperElementSlidesPerViewAttribute(
    viewportWidth: number = window.innerWidth
  ): void {
    this.productListSwiper.nativeElement.setAttribute(
      'slides-per-view',
      `${Math.ceil(viewportWidth / 820)}`
    );
  }

  private registerSlideMoving(): void {
    this.productListSwiper.nativeElement.swiper.on('touchStart', () => {
      this.productListSwiper.nativeElement.setAttribute('transparent', true);
    });
    this.productListSwiper.nativeElement.swiper.on('touchEnd', () => {
      this.productListSwiper.nativeElement.setAttribute('transparent', false);
    });
  }
}
